// BrandCarousel.tsx
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./../css/BrandCarousel.css"
const brandIcons = [
  { name: "GSPC LNG", url: "/images/clients/1.jfif" },
  { name: "Gujarat Gas Limited", url: "/images/clients/2.jfif" },
  { name: "ISRO", url: "/images/clients/3.jfif" },
  { name: "Forest Deparment of Gujarat", url: "/images/clients/4.jfif" },
  { name: "Physical Research Laboratory", url: "/images/clients/5.jfif" },
    { name: "Incread Finanace", url: "/images/clients/6.jfif" },
    { name: "ONGC", url: "/images/clients/7.jfif" },
    { name: "Advanced Systek", url: "/images/clients/8.jfif" },
    { name: "Adani", url: "/images/clients/9.svg" },
    { name: "JAMP Pharma", url: "/images/clients/10.png" },
    { name: "Uflow Automation", url: "/images/clients/11.jpg" },

    { name: "ITER", url: "/images/clients/12.svg" },
    { name: "APCON", url: "/images/clients/12.jpg" },

    // Add more icons here
];

const BrandCarousel = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };
  return (
    <div className="px-2 py-6 bg-white rounded shadow w-full max-w-screen-xl mx-auto">
    <h2 className="text-xl font-semibold text-center mb-4">Our Clients</h2>
    <Slider {...settings}>
      {brandIcons.map((brand, idx) => (
        <div key={idx} className="flex justify-center items-center h-32">
          <img
            src={brand.url}
            alt={brand.name}
            className="max-h-full max-w-full object-contain block"
            style={{ width:"200px"}}
          />
        </div>
      ))}
    </Slider>
  </div>
  );
};

export default BrandCarousel;
